import type { ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Button } from '@/shared/ui';
import { MetaIcon } from '../MetaIcon/MetaIcon';

export const MetaButton = styled((props: ButtonProps) => {
  return (
    <Button startIcon={<MetaIcon />} {...props}>
      Add account
    </Button>
  );
})(({ theme }) => ({
  width: 140,
  backgroundColor: '#4267b2',
  borderRadius: theme.shape.borderRadius * 2,

  '&:hover': {
    backgroundColor: '#36538f',
  },
})) as typeof Button;
